module.exports = __webpack_public_path__ + "c20225507deec2bb2b3619aab9f3944e.png";